import script from "./CarFilterModelSeriesChips.vue?vue&type=script&setup=true&lang=js"
export * from "./CarFilterModelSeriesChips.vue?vue&type=script&setup=true&lang=js"

import "./CarFilterModelSeriesChips.vue?vue&type=style&index=0&id=d8647bb0&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8647bb0"]])

export default __exports__